import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-devices-page-template',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="devices-template">
      <div class="devices-template__header">
        <div>
          <h1 class="devices-template__title">{{ title }}</h1>
          @if (hasSubtitle) {
            <p class="devices-template__subtitle">{{ subtitle }}</p>
          }
        </div>

        <div class="devices-template__toolbar">
          <ng-content select="[libDevicesToolbar]"></ng-content>
        </div>
      </div>

      <ng-content select="[libDevicesSecondary]"></ng-content>
      <ng-content select="[libDevicesBody]"></ng-content>
    </section>
  `,
  styles: [`
    .devices-template {
      display: grid;
      gap: 12px;
    }

    .devices-template__header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 12px;
    }

    .devices-template__title {
      margin: 0 0 8px;
      font-size: 28px;
      line-height: 1.2;
    }

    .devices-template__subtitle {
      margin: 0;
      color: #475569;
    }

    .devices-template__toolbar {
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      gap: 8px;
      flex-wrap: wrap;
    }
  `],
})
export class DevicesPageTemplateComponent {
  @Input() public title = 'Devices';
  @Input() public subtitle = '';

  protected get hasSubtitle(): boolean {
    return this.subtitle.trim().length > 0;
  }
}
